import React from 'react'
import { TicketLeg } from '@core/Areas/AccountActivity/types'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { RacingTitle } from '@mobi/betslip/Components/Common/BetCard/Components/EventDetails/Components/RacingTitle'
import { CountdownStatus } from '@core/Areas/AccountActivity/Components/Ticket/Components/Details/Components/SelectionInfo/Components/Multi/Components/CountdownStatus/CountdownStatus'

export const FallbackRaceHeader = ({ leg }: { leg: TicketLeg }) => {
  return (
    <BetCard.EventDetails
      statusComponent={<CountdownStatus multiLeg={leg} />}
      heading={
        <RacingTitle
          races={[{ raceNumber: leg.raceNumber }]}
          meetingName={leg.meetingName}
          isMultipleRaceSelection={false}
        />
      }
    />
  )
}
